import template from 'contentful/ugc-tray.j2';

import { favoriteClicked } from '../../../core/js/utils/favoritesUtils';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';

import { getUgcTrayProductRecords, ugcQuickshopOptions } from '../utils/ugcUtils';
import { ugcTraySwiperInit } from '../../../product/js/utils/swiperInits';

import { attachQuickshopLaunchEvent } from '../../../product/js/utils/tileUtils';

import { UGC_DISPLAY_TYPE_GALLERY } from '../../../product/js/enums/carouselEnums';
import { isDeviceTypeLargerThan, DEVICE_CHARACTERISTICS_SIZE } from '../../../core/js/utils/generalUtils';
import { heartClicked } from '../utils/heartsUtils';

function afterRender(store) {
    const displayType = _.get(this, `ugcConfigs.${this.multipleIndex}.displayType`, UGC_DISPLAY_TYPE_GALLERY);
    const scopingSelector = `div[data-index="${this.multipleIndex}"] ${this.templateLocation}`;
    const state = this.getState();

    ugcTraySwiperInit.bind(this)(store, scopingSelector, displayType, true);
}

export function onStateChange(store) {
    this.render(store, this, {});
}

function generateDictionary(state, dictionary, config) {
    const componentIndex = _.get(config, 'multipleIndex', 0);
    dictionary.multipleIndex = componentIndex;

    const ugc = {
        ugc: _.get(state, `core.ugc.${componentIndex}`, {})
    };

    return Object.assign({}, state, ugc, dictionary);
}

export function attachEvents(store, componentIndex) {
    const scope = `div[data-index="${componentIndex}"]`;
    const ugcTileSelector = `${scope} .js-ugc-tray-image-container`;

    attachQuickshopLaunchEvent(store, this, () => getUgcTrayProductRecords(store, componentIndex), ugcQuickshopOptions);

    // eslint-disable-next-line arrow-body-style
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-favorite-toggle'), (e) => {
        return favoriteClicked(store, e);
    });

    document.addEventListener('play', (e) => {
        const video = $(e.target).parents('.js-ugc-tray-image-container').children('video');

        const videoIcon = $(e.target).parent().children('.js-ugc-video-icon');
        videoIcon.hide();

        video.on('click', () => {
            $(video).off('click');
            video.get(0).pause();
        });
    }, true);

    document.addEventListener('pause', (e) => {
        const videoIcon = $(e.target).parent().children('.js-ugc-video-icon');
        videoIcon.show();
    }, true);

    $(document).on('click', '.js-ugc-video-icon', (e) => {
        const video = $(e.target).parents('.js-ugc-tray-image-container').children('video');

        video.get(0).play();
    });

    $(document).on(this.scopedEvent('click'), '.js-heart-toggle', { selector: ugcTileSelector }, (e) => heartClicked(store, e));

}

/**
 * Bootstrap the component onto the page
 *
 * overrides must pass in `ugcConfigs`
 * @param {object} store The redux store
 * @param {object} overrides Component config override object
 * @returns {object} The component utils generator function
 */
export function init(store, overrides = {}) {
    const config = {
        children: [ ],
        multiwatch: (index) => `core.ugc.${index}.tray`,
        ugcConfigs: overrides.ugcConfigs,
        template: template,
        templateLocation: '.dom-ugc-tray-carousel',
        onStateChange: onStateChange,
        afterRender: afterRender,
        attachEvents: attachEvents,
        generateDictionary: generateDictionary
    };

    config.multiple = () => overrides.ugcConfigs.length;

    return generate(config, store, overrides, getDefaultOptions(store));
}
